<template>
  <v-hover v-slot:default="{ hover }">
    <v-card
      :to="{ name: 'article', params: { locale: $i18n.locale, articleId: id } }"
      :elevation="hover ? 12 : 2"
      max-width="350"
    >
      <v-img aspect-ratio="1" :src="imgSrc"></v-img>
      <v-card-title class="mx-1 pl-3 subtitle-2 text-left">{{ title }}</v-card-title>
      <v-card-subtitle class="pb-1 pt-1 pr-3">{{date}}</v-card-subtitle>
    </v-card>
  </v-hover>
</template>

<script>
export default {
  name: "articleCard",
  props: ["title", "imgSrc", "date", "id"]
};
</script>

<style scoped>
.nowrap {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
